import NavButton from 'components/ui/Button/NavButton';
import CardEvaluation from 'components/ui/CardEvaluation';
import Filter from 'components/ui/Filter';
import ModalWarning from 'components/ui/ModalWarning';
import Pagination from 'components/ui/Pagination';
import Spinner from 'components/ui/Spinner';
import StepNav from 'components/ui/StepNav';
import StepTitle from 'components/ui/StepTitle';
import { useAuth } from 'context/AuthContext';
import { useModal } from 'context/ModalContext/Modal.context';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { getEvaluatorRealizations, getEvaluatedRealizationsDirector, getEvaluationRealizations, newEvaluateRealization, verifyTasksByPrefixo } from 'services/evaluation.service';
import { categories, RealizationEvItem } from 'types/realization';
import { clearRegistrationUser } from 'utils/fns';

const DirectorEvaluationVote = () => {
    const navigate = useNavigate();
    const { user } = useAuth();
    const { showModal, closeModal } = useModal();

    const [loadingRealizations, setLoadingRealizations] = useState(false);
    const [categories, setCategories] = useState<categories[]>([]);
    const [currentCategory, setCurrentCategory] = useState<categories>();
    const [currentIndexCategory, setCurrentIndexCategory] = useState(0);
    const [realizations, setRealizations] = useState<RealizationEvItem[]>([]);
    const [filteredRealization, setFilteredRealization] = useState<RealizationEvItem[]>([]);
    const [selectedEvaluations, setSelectedEvaluations] = useState<{ realizationId: string; evaluation: string }[]>([]);
    const [selectedRealizations, setSelectedRealizations] = useState<RealizationEvItem[]>([]);
    const [selectedRealRealizations, setSelectedRealRealizations] = useState<RealizationEvItem[]>([]);
    const [selectedToVote, setSelectedToVote] = useState<RealizationEvItem[]>([]);
    const [isSelectLastCategory, setIsSelectLastCategory] = useState(false);

    const [filter, setFilter] = useState<{
        searchTerm?: string;
    }>({});

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    const [currentItens, setCurrentItens] = useState<RealizationEvItem[]>([]);
    const [totalPages, setTotalPages] = useState(0);
    const [limit, setLimit] = useState(0);

    const [isSendEvaluate, setIsSendEvaluate] = useState(false);

    useEffect(() => {
        fetchRealizations();
    }, [user]);

    const fetchRealizations = async () => {
        setLoadingRealizations(true);
        try {
            if (!!user) {
                const VerifyData = await verifyTasksByPrefixo(user)

                if (user?.detail.isDirector || user?.detail.acessor || !!VerifyData) {
                    
                    const data = await getEvaluatorRealizations(user);

                    const items = data ? data.flatMap((item) => item.realizations) : [];

                    let newCategories = data
                        ? data.map((item) => {
                            return {
                                name: `${item.categoryName}`,
                                _id: item.categoryName,
                                count: item.realizations.length
                            };
                        })
                        : [];

                    const categoriesList = newCategories.sort((a, b) => {
                        return a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' });
                    });

                    setCategories(categoriesList);

                    setRealizations(items);

                    setCurrentCategory(categoriesList[0]);
                    setCurrentIndexCategory(0);

                    const indexOfLastItem = currentPage * perPage;
                    const indexOfFirstItem = indexOfLastItem - perPage;
                    const totalPages = Math.ceil(data.length / perPage);
                    setTotalPages(totalPages);
                }
            }
        } catch (e) {
        } finally {
            setLoadingRealizations(false);
        }
    };

    useEffect(() => {
        let filtered = realizations.filter((item) => item.categoria === currentCategory?.name);

        console.log('size_itens', filtered.length);

        if (filtered.length < 3) {
            setSelectedRealizations(filtered);
            setSelectedRealRealizations((prev) => {
                return [...prev, ...filtered.filter((item) => !prev.some((f) => f._id === item._id))];
            });

            setFilteredRealization((prev) => prev.filter((item) => !filtered.some((f) => f._id === item._id)));
        } else {
            setFilteredRealization(filtered);
        }

        if (user?.detail.isDirector || user?.detail.acessor || user?.detail.isSpecialist) {
            setLimit(3);
        } else {
            setLimit(1);
        }
        setCurrentPage(1);
    }, [currentCategory]);

    useEffect(() => {
        const indexOfLastItem = currentPage * perPage;
        const indexOfFirstItem = indexOfLastItem - perPage;
        setCurrentItens(filteredRealization.slice(indexOfFirstItem, indexOfLastItem));

        const totalPages = Math.ceil(filteredRealization.length / perPage);
        setTotalPages(totalPages);
    }, [currentPage, perPage, filteredRealization]);

    const nextCategory = () => {
        console.log(currentIndexCategory < categories.length - 1);
        console.log({ ci: currentIndexCategory + 1, l: categories.length - 1 });
        if (currentIndexCategory + 1 == categories.length - 1) {
            setIsSelectLastCategory(true);
        }
        if (currentIndexCategory < categories.length - 1) {
            setSelectedToVote(selectedRealizations);
            setSelectedRealizations([]);
            setCurrentIndexCategory((prevIndex) => {
                const newIndex = prevIndex + 1;
                setCurrentCategory(categories[newIndex]);
                return newIndex;
            });
        }

        if (isSelectLastCategory) {
        }
    };

    const handleSearch = (term: string) => {
        let filteredResult = realizations.filter((item) => {
            const matchesSearchTerm = item.title.toLowerCase().includes(term.toLocaleLowerCase());
            return matchesSearchTerm;
        });
        setFilteredRealization(filteredResult);
        setCurrentPage(1);
    };

    const handlerEvaluate = async () => {
        setIsSendEvaluate(true);

        function onCloseModal() {
            closeModal();
        }

        try {
            if (!!user) {
                if (user.detail?.acessor?.vp) {
                    showModal(
                        'evaluation-limit',
                        <ModalWarning title={`Ops!`} description="Você está simulando o voto no Prêmio BB. Mas seu voto não pode ser enviado." btnText="Continuar" onClose={onCloseModal} />,
                        'evaluation-limit'
                    );
                    return;
                } else {
                    let check = await getEvaluatedRealizationsDirector(user);

                    if (!!check && check.realizations.length > 0) {
                        showModal('evaluation-limit', <ModalWarning title={`Ops!`} description="Você já votou uma vez!" btnText="Continuar" onClose={onCloseModal} />, 'evaluation-limit');
                        return;
                    }

                    let currentPlayer = clearRegistrationUser(user?._id);

                    const result = await newEvaluateRealization({
                        player: currentPlayer,
                        rawPlayer: user._id,
                        date: new Date(),
                        realizations: selectedRealRealizations,
                        step: 3
                    });

                    navigate('/evaluation-realization');
                }
            }
        } catch (e) {
            console.log(e);
        } finally {
            setIsSendEvaluate(false);
        }
    };

    const onSelectRealization = (realization: RealizationEvItem) => {
        if (selectedRealizations.length >= limit) {
            showModal(
                'limit-participants',
                <ModalWarning
                    title={`Você já indicou ${limit} realizações! `}
                    description="Para selecionar outra INICIATIVA, é necessário desmarcar uma realização selecionada anteriormente."
                    btnText="Continuar"
                    onClose={closeModal}
                />,
                'participant-limit'
            );
        } else {
            setSelectedRealRealizations((prev) => {
                if (!prev.some((item) => item._id === realization._id)) {
                    return [...prev, realization];
                }
                return prev;
            });

            setSelectedRealizations((prev) => {
                if (!prev.some((item) => item._id === realization._id)) {
                    return prev.length < limit ? [...prev, realization] : prev;
                }
                return prev;
            });

            setFilteredRealization((prev) => prev.filter((item) => item._id !== realization._id));
        }
    };

    const onRemove = (realization: RealizationEvItem) => {
        console.log('onremove', realization);
        setSelectedRealizations((prev) => {
            const updated = prev.filter((item) => item._id !== realization._id);
            console.log('Updated selectedRealizations:', updated);
            return updated;
        });

        setSelectedRealRealizations((prev) => {
            const updated = prev.filter((item) => item._id !== realization._id);
            console.log('Updated selectedRealizations:', updated);
            return updated;
        });

        setSelectedEvaluations((prev) => {
            const updated = prev.filter((ev) => ev.realizationId !== realization._id);
            console.log('Updated selectedEvaluations:', updated);
            return updated;
        });

        setFilteredRealization((prev) => {
            const updated = [...prev.filter((item) => item._id !== realization._id), realization];
            console.log('Updated filteredRealization:', updated);
            return updated;
        });

        if (user?.detail.isDirector || user?.detail.acessor || user?.detail.isSpecialist) {
            setLimit(3);
        } else {
            setLimit(1);
        }
    };

    const confirmVote = () => {
        showModal(
            'confirm-vote',
            <ModalWarning title="Confirma o envio do seu voto?" description={""} categories={categories} selectedRealizations={selectedRealRealizations} btnText="Enviar voto" hasBackButton={true} onClose={handlerEvaluate} onBackButton={closeModal} />,
            'confirm-vote'
        );
    };

    return (
        <>
            {loadingRealizations && (
                <div className="flex items-start justify-center w-full h-screen">
                    <div className="flex flex-col">
                        <Spinner />
                        <span className="text-center text-blue-bb">Carregando...</span>
                    </div>
                </div>
            )}

            {!loadingRealizations && (
                <>
                    <StepNav currentStep={4} activeSubStep={1} />

                    <StepTitle title={'Etapa 3 de avaliação'} description={`Selecione  ${limit > 1 ? `as ${limit} iniciativas` : 'a iniciativa'} que mais ${limit > 1 ? `representam` : 'representa'} cada umas das 5 categorias do Prêmio BB 2024 - ASG, Clientes, Financeira, Pessoas e Cultura, Transformação Digital e Processos. Para auxiliar na sua escolha, verifique a documentação complementar (vídeo e ou PDF) e clique em "Ver mais" para conhecer detalhes de cada realização.`} />

                    <div className="mx-4 mb-0 md:mb-16 md:mx-0">
                        <div className="flex flex-col items-center mb-12 md:flex-row md:justify-between">
                            <h2 className="text-gray-bb-1 font-title text-xl md:text-[26px] mb-0">
                                <strong>{currentCategory?.name}</strong> - {currentIndexCategory + 1}ª de {categories.length} Categorias
                            </h2>
                            <NavButton
                                text={isSelectLastCategory ? 'Enviar' : 'Ir para a próxima categoria'}
                                bgColor={'#FCFC30'}
                                disabled={!selectedRealizations.length ? true : false}
                                isLoading={false}
                                onClick={isSelectLastCategory ? confirmVote : nextCategory}
                            />
                        </div>
                        <h2 className="text-gray-bb-1 font-title text-xl md:text-[26px] mb-8 font-bold">
                                        Realizações selecionadas ({selectedRealizations.length}/{limit})
                                    </h2>
                        {selectedRealizations.length === 0 && (
                            <p>
                                Você ainda não selecionou nenhuma realização da categoria <strong>{currentCategory?.name}</strong>.
                            </p>
                        )}
                        {selectedRealizations.map((item: RealizationEvItem, index: number) => (
                            <CardEvaluation
                                data={item}
                                key={item._id}
                                qtdEvaluation={realizations.length}
                                allowRemove={true}
                                onSelect={(e) => {
                                    console.log('selected', e);
                                }}
                                selectedEvaluations={selectedEvaluations}
                                onEvaluation={function (val?: RealizationEvItem): void {
                                    throw new Error('Function not implemented.');
                                }}
                                onRemove={onRemove}
                                showOptions={false}
                            />
                        ))}
                    </div>

                    <div className="mb-8 border-b border-blue-bb">
                        <h3 className="py-4 text-sm font-bold text-center text-blue-bb">
                            {currentCategory?.name}({currentCategory?.count})
                        </h3>
                    </div>

                    <div>
                        <div className="flex items-end justify-end">
                            <div className="w-full">
                                <Filter
                                    enableCategoryFilter={false}
                                    onChange={(key, value) => {
                                        handleSearch(value);
                                        setFilter((prev) => ({ ...filter, [key]: value }));
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    {!(realizations.length <= limit) && (
                        <>
                            <div className="grid-cols-1 mx-4 md:grid md:mx-0 md:grid-cols-2 gap-7 content">
                                {currentItens.map((item: RealizationEvItem, index: number) => (
                                    <CardEvaluation
                                        qtdEvaluation={realizations.length}
                                        data={item}
                                        key={item._id}
                                        onSelect={onSelectRealization}
                                        onEvaluation={function (val?: RealizationEvItem): void {
                                            throw new Error('Function not implemented.');
                                        }}
                                        onRemove={function (val?: RealizationEvItem): void {
                                            throw new Error('Function not implemented.');
                                        }}
                                        showOptions={false}
                                    />
                                ))}
                            </div>

                            <Pagination totalPages={totalPages} currentPage={currentPage} onPage={setCurrentPage} />
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default DirectorEvaluationVote;
